export default {
    name: 'OfferOccupationLimit',
    props: { show: Boolean, width: String, height: String, isMobile: Boolean },
    data() {
        return {
            nextOccupationDate: ''
        };
    }
};
